/* eslint-disable @typescript-eslint/no-unused-vars */
// @ts-nocheck
/**
 * This file Copyright (c) 2010-2021 Magnolia International
 * Ltd.  (http://www.magnolia-cms.com). All rights reserved.
 *
 *
 * This program and the accompanying materials are made
 * available under the terms of the Magnolia Network Agreement
 * which accompanies this distribution, and is available at
 * http://www.magnolia-cms.com/mna.html
 *
 * Any modifications to this file must keep this entire header
 * intact.
 *
 */
// Auto generated file, don't change manually

import type {
  Asset,
  Rendition
} from '../../magnolia/lib/MagnoliaAsset';
import {
  transformNode,
  transformResults
} from '../../magnolia/lib/MagnoliaPropertyHelper';

export interface switchableStruct {
  field: string;
  page: any;
  intLinkParam ? : string;
  external: string;
  download: Asset;
}
export interface switchableModeStruct {
  field: string;
  title ? : string;
  image ? : Asset;
  alt ? : string;
  imageTitle ? : string;
}
export interface topLevelLinksStruct {
  switchable ? : switchableStruct;
  linkTargetMode ? : string;
  switchableMode ? : switchableModeStruct;
}
export interface switchableStruct {
  field: string;
  page: any;
  intLinkParam ? : string;
  external: string;
  download: Asset;
}
export interface additionalLinksStruct {
  switchable ? : switchableStruct;
  linkTargetMode ? : string;
  title ? : string;
}
export interface categoriesStruct {
  category: string;
  additionalLinks ? : Array < additionalLinksStruct > ;
}
export interface switchableStruct {
  field: string;
  page: any;
  intLinkParam ? : string;
  external: string;
  download: Asset;
}
export interface mobileAspectRatioStruct {
  aspectRatio ? : string;
}
export interface imagesStruct {
  switchable ? : switchableStruct;
  linkTargetMode ? : string;
  title ? : string;
  image: Asset;
  alt: string;
  aspectRatio ? : string;
  mobileAspectRatio ? : Array < mobileAspectRatioStruct > ;
}
export interface imageConfigurationStruct {
  category: string;
  images ? : Array < imagesStruct > ;
}
export default interface Header {
  showBasket ? : boolean;
  topLevelLinks ? : Array < topLevelLinksStruct > ;
  showStoreFinder ? : boolean;
  showMyAccount ? : boolean;
  categories ? : Array < categoriesStruct > ;
  imageConfiguration ? : Array < imageConfigurationStruct > ;
  metadata ? : any;
}

export const Props = {
  showBasket: Boolean,
  topLevelLinks: Array as() => Array < topLevelLinksStruct > ,
  showStoreFinder: Boolean,
  showMyAccount: Boolean,
  categories: Array as() => Array < categoriesStruct > ,
  imageConfiguration: Array as() => Array < imageConfigurationStruct > ,
  metadata: Object,
}

export const WrapperProps = {
  showBasket: Boolean,
  topLevelLinks: Object,
  showStoreFinder: Boolean,
  showMyAccount: Boolean,
  categories: Object,
  imageConfiguration: Object,
  metadata: Object,
}

export class HeaderBuilder {
  static build(props: any) {
    props = transformNode(JSON.parse(JSON.stringify(props)));
    class HeaderInstance implements Header {
      showBasket ? : boolean;
      topLevelLinks ? : Array < topLevelLinksStruct > ;
      showStoreFinder ? : boolean;
      showMyAccount ? : boolean;
      categories ? : Array < categoriesStruct > ;
      imageConfiguration ? : Array < imageConfigurationStruct > ;
      metadata ? : any;

      constructor(props: any) {
        Object.assign(this, props);

        if (this.topLevelLinks) {
          this.topLevelLinks = Object.entries(this.topLevelLinks)
            .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'topLevelLinks' + '[0123456789]+')))
            .map((pair: [string, any]) => ({
              ...pair[1]
            }));
          for (let i1 = 0; i1 < this.topLevelLinks.length; i1++) {

            if (this.topLevelLinks[i1]) {
              if (this.topLevelLinks[i1].switchable) {
                if (typeof this.topLevelLinks[i1].switchable.download === 'object') {
                  this.topLevelLinks[i1].switchable.download = {
                    ...this.topLevelLinks[i1].switchable.download,
                    link: this.topLevelLinks[i1].switchable.download['@link'],
                    name: this.topLevelLinks[i1].switchable.download['@name'],
                    path: this.topLevelLinks[i1].switchable.download['@path'],
                  };
                } else {
                  this.topLevelLinks[i1].switchable.download = null as any;
                }
              }
            }

            if (this.topLevelLinks[i1]) {
              if (this.topLevelLinks[i1].switchableMode) {
                if (typeof this.topLevelLinks[i1].switchableMode.image === 'object') {
                  this.topLevelLinks[i1].switchableMode.image = {
                    ...this.topLevelLinks[i1].switchableMode.image,
                    link: this.topLevelLinks[i1].switchableMode.image['@link'],
                    name: this.topLevelLinks[i1].switchableMode.image['@name'],
                    path: this.topLevelLinks[i1].switchableMode.image['@path'],
                  };
                } else {
                  this.topLevelLinks[i1].switchableMode.image = null as any;
                }
              }
            }
          }
        } else {
          this.topLevelLinks = null as any;
        }
        if (this.categories) {
          this.categories = Object.entries(this.categories)
            .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'categories' + '[0123456789]+')))
            .map((pair: [string, any]) => ({
              ...pair[1]
            }));
          for (let i1 = 0; i1 < this.categories.length; i1++) {
            if (this.categories[i1]) {
              if (this.categories[i1].additionalLinks) {
                this.categories[i1].additionalLinks = Object.entries(this.categories[i1].additionalLinks)
                  .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'additionalLinks' + '[0123456789]+')))
                  .map((pair: [string, any]) => ({
                    ...pair[1]
                  }));
                for (let i2 = 0; i2 < this.categories[i1].additionalLinks.length; i2++) {

                  if (this.categories[i1]) {
                    if (this.categories[i1].additionalLinks[i2]) {
                      if (this.categories[i1].additionalLinks[i2].switchable) {
                        if (typeof this.categories[i1].additionalLinks[i2].switchable.download === 'object') {
                          this.categories[i1].additionalLinks[i2].switchable.download = {
                            ...this.categories[i1].additionalLinks[i2].switchable.download,
                            link: this.categories[i1].additionalLinks[i2].switchable.download['@link'],
                            name: this.categories[i1].additionalLinks[i2].switchable.download['@name'],
                            path: this.categories[i1].additionalLinks[i2].switchable.download['@path'],
                          };
                        } else {
                          this.categories[i1].additionalLinks[i2].switchable.download = null as any;
                        }
                      }
                    }
                  }
                }
              } else {
                this.categories[i1].additionalLinks = null as any;
              }
            }
          }
        } else {
          this.categories = null as any;
        }
        if (this.imageConfiguration) {
          this.imageConfiguration = Object.entries(this.imageConfiguration)
            .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'imageConfiguration' + '[0123456789]+')))
            .map((pair: [string, any]) => ({
              ...pair[1]
            }));
          for (let i1 = 0; i1 < this.imageConfiguration.length; i1++) {
            if (this.imageConfiguration[i1]) {
              if (this.imageConfiguration[i1].images) {
                this.imageConfiguration[i1].images = Object.entries(this.imageConfiguration[i1].images)
                  .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'images' + '[0123456789]+')))
                  .map((pair: [string, any]) => ({
                    ...pair[1]
                  }));
                for (let i2 = 0; i2 < this.imageConfiguration[i1].images.length; i2++) {

                  if (this.imageConfiguration[i1]) {
                    if (this.imageConfiguration[i1].images[i2]) {
                      if (this.imageConfiguration[i1].images[i2].switchable) {
                        if (typeof this.imageConfiguration[i1].images[i2].switchable.download === 'object') {
                          this.imageConfiguration[i1].images[i2].switchable.download = {
                            ...this.imageConfiguration[i1].images[i2].switchable.download,
                            link: this.imageConfiguration[i1].images[i2].switchable.download['@link'],
                            name: this.imageConfiguration[i1].images[i2].switchable.download['@name'],
                            path: this.imageConfiguration[i1].images[i2].switchable.download['@path'],
                          };
                        } else {
                          this.imageConfiguration[i1].images[i2].switchable.download = null as any;
                        }
                      }
                    }
                  }
                  if (this.imageConfiguration[i1]) {
                    if (this.imageConfiguration[i1].images[i2]) {
                      if (typeof this.imageConfiguration[i1].images[i2].image === 'object') {
                        this.imageConfiguration[i1].images[i2].image = {
                          ...this.imageConfiguration[i1].images[i2].image,
                          link: this.imageConfiguration[i1].images[i2].image['@link'],
                          name: this.imageConfiguration[i1].images[i2].image['@name'],
                          path: this.imageConfiguration[i1].images[i2].image['@path'],
                        };
                      } else {
                        this.imageConfiguration[i1].images[i2].image = null as any;
                      }
                    }
                  }
                  if (this.imageConfiguration[i1]) {
                    if (this.imageConfiguration[i1].images[i2]) {
                      if (this.imageConfiguration[i1].images[i2].mobileAspectRatio) {
                        this.imageConfiguration[i1].images[i2].mobileAspectRatio = Object.entries(this.imageConfiguration[i1].images[i2].mobileAspectRatio)
                          .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'mobileAspectRatio' + '[0123456789]+')))
                          .map((pair: [string, any]) => ({
                            ...pair[1]
                          }));
                      } else {
                        this.imageConfiguration[i1].images[i2].mobileAspectRatio = null as any;
                      }
                    }
                  }
                }
              } else {
                this.imageConfiguration[i1].images = null as any;
              }
            }
          }
        } else {
          this.imageConfiguration = null as any;
        }
      }
    }
    return new HeaderInstance(props);
  }
}
